// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --main-color: #ee8c71;
  --sec-color: #2d9989;
  --btn-bg-color: #2d9989;
  --btn-txt-color: white;
  --bg-color: white;
}

html, body {
  overflow-x: hidden;
  margin: 0;
  padding: 0;
  font-family: sans-serif, monospace;
  height: 100%;
  width: 100%;
}

.form-control {
  background-color: transparent !important;
  border-radius: 0 !important;
  border: none !important;
  border-bottom: 2px solid var(--main-color) !important;
  color: var(--main-color) !important;
}

body {
  background-color: var(--bg-color);
}

.bg-decor {
  position: absolute;
  left: 0;
  width: 100%;
  z-index: 0;
  pointer-events: none;
  background-size: cover;
  background-repeat: no-repeat;
}

.bg-top {
  top: 0;
  height: 200px;
  background-position: bottom center;
}

.bg-bot {
  bottom: 0;
  height: 300px;
  background-position: top center;
}

.page-content {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.logo-box {
  width: 120px;
  background: white;
  padding: 10px;
  border-bottom-left-radius: 16px;
}

label {
  color: var(--main-color);
  font-weight: bold;
}

#email, #nome {
  padding: 0 0 0 0.5rem;
  margin: 0;
  border-radius: 0;
  background-color: transparent;
  border: none;
  border-bottom: 1px solid var(--main-color);
  color: var(--main-color);
}

#email:focus, #nome:focus {
  color: var(--main-color);
  background-color: none;
  border: none;
  border-bottom: 1px solid var(--main-color);
  outline: 0;
  box-shadow: none;
}

#mensagem {
  border: none;
  border-bottom: 1px solid var(--main-color);
  color: var(--main-color);
}

#title {
  color: var(--main-color);
}

#btn-submit, .btn-custom {
  background-color: var(--btn-bg-color);
  color: var(--btn-txt-color);
  border: 1px solid var(--btn-bg-color);
  box-shadow: none;
}

.btn-custom:hover {
  color: var(--btn-bg-color);
  background-color: var(--btn-txt-color);
  border: 1px solid var(--btn-bg-color);
  box-shadow: none;
}

#entrar {
  width: 21%;
  margin: 0;
  border: none;
  font-weight: bold;
  cursor: pointer;
  color: var(--btn-txt-color);
  background-color: var(--btn-bg-color);
  outline: none;
}

#container-container {
  margin: auto;
  width: 55%;
  display: flex;
  box-sizing: border-box;
  align-items: center;
  flex-direction: inherit;
}

.iframe-wrapper {
  position: relative;
  width: 100%;
  padding-top: 54%;
  overflow: hidden;
}

.iframe-wrapper iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
  z-index: 1;
}

.form-container {
  position: relative;
  z-index: 2;
}

@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait) {
  .iframe-wrapper {
    padding-top: 34vh;
  }
  #email, #nome, label {
    font-size: 0.8em;
  }
}`, "",{"version":3,"sources":["webpack://./src/icesp/styles/main.scss"],"names":[],"mappings":"AAAA;EACI,qBAAA;EACA,oBAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,kCAAA;EACA,YAAA;EACA,WAAA;AACJ;;AACA;EACI,wCAAA;EACA,2BAAA;EACA,uBAAA;EACA,qDAAA;EACA,mCAAA;AAEJ;;AAAA;EACI,iCAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,OAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;EACA,sBAAA;EACA,4BAAA;AAGJ;;AAAA;EACI,MAAA;EACA,aAAA;EACA,kCAAA;AAGJ;;AAAA;EACI,SAAA;EACA,aAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,kBAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAGJ;;AAAA;EACI,YAAA;EACA,iBAAA;EACA,aAAA;EACA,+BAAA;AAGJ;;AAAA;EACI,wBAAA;EACA,iBAAA;AAGJ;;AAAA;EACI,qBAAA;EACA,SAAA;EACA,gBAAA;EACA,6BAAA;EACA,YAAA;EACA,0CAAA;EACA,wBAAA;AAGJ;;AAAA;EACI,wBAAA;EACA,sBAAA;EACA,YAAA;EACA,0CAAA;EACA,UAAA;EACA,gBAAA;AAGJ;;AADA;EACI,YAAA;EACA,0CAAA;EACA,wBAAA;AAIJ;;AADA;EACI,wBAAA;AAIJ;;AAFA;EACI,qCAAA;EACA,2BAAA;EACA,qCAAA;EACA,gBAAA;AAKJ;;AAHA;EACI,0BAAA;EACA,sCAAA;EACA,qCAAA;EACA,gBAAA;AAMJ;;AAJA;EACI,UAAA;EAAY,SAAA;EAAW,YAAA;EAAc,iBAAA;EAAmB,eAAA;EACxD,2BAAA;EACA,qCAAA;EACA,aAAA;AAWJ;;AATA;EACI,YAAA;EAEA,UAAA;EAEA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,UAAA;AAUJ;;AAPA;EACI,kBAAA;EACA,UAAA;AAUJ;;AAPA;EAEI;IACI,iBAAA;EASN;EANE;IACI,gBAAA;EAQN;AACF","sourcesContent":[":root{\n    --main-color: #ee8c71;\n    --sec-color: #2d9989;\n    --btn-bg-color: #2d9989;\n    --btn-txt-color: white;\n    --bg-color: white;\n}\n\nhtml, body{\n    overflow-x: hidden;\n    margin: 0;\n    padding: 0;\n    font-family: sans-serif, monospace;\n    height: 100%;\n    width: 100%;\n}\n.form-control{\n    background-color: transparent !important;\n    border-radius: 0 !important;\n    border: none !important;\n    border-bottom: 2px solid var(--main-color) !important;\n    color: var(--main-color) !important;\n}\nbody{\n    background-color: var(--bg-color);\n}\n\n.bg-decor {\n    position: absolute;\n    left: 0;\n    width: 100%;\n    z-index: 0;\n    pointer-events: none;\n    background-size: cover;\n    background-repeat: no-repeat;\n}\n\n.bg-top {\n    top: 0;\n    height: 200px;\n    background-position: bottom center;\n}\n\n.bg-bot {\n    bottom: 0;\n    height: 300px;\n    background-position: top center;\n}\n\n.page-content {\n    position: relative;\n    z-index: 1;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.logo-box {\n    width: 120px;\n    background: white;\n    padding: 10px;\n    border-bottom-left-radius: 16px;\n}\n\nlabel{\n    color: var(--main-color);\n    font-weight: bold;\n}\n\n#email, #nome{\n    padding: 0 0 0 0.5rem;\n    margin: 0;\n    border-radius: 0;\n    background-color: transparent;\n    border: none;\n    border-bottom: 1px solid var(--main-color);\n    color: var(--main-color);\n}\n\n#email:focus, #nome:focus {\n    color: var(--main-color);\n    background-color: none;\n    border: none;\n    border-bottom: 1px solid var(--main-color);\n    outline: 0;\n    box-shadow: none;\n}\n#mensagem{\n    border: none;\n    border-bottom: 1px solid var(--main-color);\n    color: var(--main-color);\n}\n\n#title{\n    color: var(--main-color);\n}\n#btn-submit, .btn-custom{\n    background-color: var(--btn-bg-color);\n    color: var(--btn-txt-color);\n    border: 1px solid var(--btn-bg-color);\n    box-shadow: none;\n}\n.btn-custom:hover{\n    color: var(--btn-bg-color);\n    background-color: var(--btn-txt-color);\n    border: 1px solid var(--btn-bg-color);\n    box-shadow: none;\n}\n#entrar{\n    width: 21%; margin: 0; border: none; font-weight: bold; cursor: pointer;\n    color: var(--btn-txt-color);\n    background-color: var(--btn-bg-color);\n    outline: none;\n}\n#container-container{\n    margin: auto;\n\n    width: 55%;\n\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    flex-direction: inherit;\n}\n\n.iframe-wrapper {\n    position: relative;\n    width: 100%;\n    padding-top: 54%;\n    overflow: hidden;\n}\n\n.iframe-wrapper iframe {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border: 0;\n    z-index: 1;\n}\n\n.form-container {\n    position: relative;\n    z-index: 2;\n}\n\n@media (min-width: 320px) and (max-width: 1024px) and (orientation: portrait)  {\n\n    .iframe-wrapper {\n        padding-top: 34vh;\n    }\n\n    #email, #nome, label {\n        font-size: 0.8em;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
